import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

const header = () =>  {
  let { pathname } = useLocation();
  return (
      <Container id="header" className="page-header">
        <h1>
          Henserver &nbsp;<small>Ryan Henao</small><br />
          <div id="navItems">
            <small><NavLink to="/portfolio" className={({isActive, isPending}) => isActive || pathname == "/" ? "active": "" }>Portfolio</NavLink></small>
            <small><NavLink to="/booklist">Booklist</NavLink></small>
            <small><NavLink to="/gallery">Gallery</NavLink></small>
            <small><NavLink to="/essays">Essays</NavLink></small>
            <small><NavLink to="/videos">Videos</NavLink></small>
          </div>
        </h1>
        <hr></hr>
      </Container>
  );
}

export default header;